import { takeLatest } from 'redux-saga/effects';
import { navigationBuildAction } from 'common/actions/navigation';
import { navigationBuildEffect } from 'common/sagas/effects';

export const navigationSaga = function* () {
  yield takeLatest(navigationBuildAction().type, navigationBuildEffect);

  /**
   * Put here other sagas
   */
};
